import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    DOCUMENT,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    ViewChildren
} from '@angular/core';

import {AimoCategoryHierarchy, AimoFacetValue} from '../../../../model/product.model';
import {AimoCategoryService} from "../../../../service/category/aimo-category.service";
import {Observable, Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbPopover} from "@ng-bootstrap/ng-bootstrap";
import {AimoProductFacetService} from "../../../../service/product/aimo-product-facet.service";

export const MAX_CATEGORIES = 10;

@Component({
    selector: 'aimo-category-header-subcategory',
    templateUrl: './aimo-category-header-subcategory.component.html',
    standalone: false
})
export class AimoCategoryHeaderSubcategoryComponent implements AfterViewInit, OnDestroy, OnChanges, OnInit {
    @Input() values: AimoCategoryHierarchy[];
    @Input() categoryId: string;
    @Input() link: string;
    @Input() showAll = false;

    @Output() showAllAction = new EventEmitter<boolean>();

    @ViewChildren(NgbPopover) popovers!: QueryList<NgbPopover>;
    addedPopOvers = []

    subscriptions: Subscription = new Subscription();

    categoryName: string;
    categoryCount: number;
    isMobileUi: boolean;

    constructor(protected categoryService: AimoCategoryService,
                protected cdr: ChangeDetectorRef,
                @Inject(DOCUMENT) protected document: Document,
                protected productFacetService: AimoProductFacetService,
                protected activatedRoute: ActivatedRoute,
                protected router: Router,) {
    }

    ngOnInit(): void {
        this.isMobileUi = this.document.defaultView.window?.matchMedia('only screen and (max-width: 760px)').matches;
    }

    ngAfterViewInit(): void {
        this.categoryService.closePopovers(this.popovers, this.addedPopOvers, this.subscriptions);
    }

    ngOnChanges(): void {
        setTimeout(() => {
            this.ngAfterViewInit();
        }, 1000);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    toggleShowAll(): void {
        this.showAll = !this.showAll;
        this.showAllAction.emit(this.showAll);
    }

    getCategories(values: AimoCategoryHierarchy[]): AimoCategoryHierarchy[] {
        return this.showAll ? values : values.slice(0, MAX_CATEGORIES);
    }

    showToggle(length: number): boolean {
        return length > MAX_CATEGORIES;
    }

    getCategory(query: string): Observable<AimoFacetValue[]> {
        return this.categoryService.getCategory(query);
    }

    openCategoryFacet(category: string, subcategoryId: string, name: string, count: number, query: string, divCategories: HTMLDivElement, subLevel: boolean): void {
        if (this.categoryId === '0') {
            this.router.navigate(['/category/' + subcategoryId]);
            return;
        }
        if (!subLevel && this.isMobileUi && this.popovers.filter(pop => pop.popoverContext.name === name && pop.isOpen()).length === 0) {
            return;
        }
        this.categoryName = name;
        this.categoryCount = count;
        this.cdr.detectChanges();
        this.router.navigate(['/category/' + category], {
            queryParams: {query: query},
        //    fragment: 'category-content-anchor'
        });
        this.productFacetService.setScrollPosition(this.document.defaultView.window.pageYOffset);
        divCategories.focus();
    }

    protected generateCategoryQuery(facet: AimoCategoryHierarchy): string {
        return '*:relevance:categoryLevel2:' + facet.id + ':category:';
    }

    protected isSelected(subCategory: AimoCategoryHierarchy): boolean {
        return this.activatedRoute.snapshot.queryParams['query']?.indexOf('categoryLevel2:' + subCategory.id) > -1;
    }

    private openTimeoutId: any;

    openPopup(popover: NgbPopover) {
        if (this.isMobileUi) {
            return;
        }
        // Set a delayed open action (e.g., 500ms)
        this.openTimeoutId = setTimeout(() => {
            if (!popover.isOpen()) {
                this.openTimeoutId = null;
                popover.open();
            }
        }, 1000);
    }

    clearPopupTimeout(popover: NgbPopover) {
        if (this.openTimeoutId && !this.isMobileUi) {
            clearTimeout(this.openTimeoutId);
            this.openTimeoutId = null;
        }
    }

    @HostListener('document:click', ['$event'])
    closePopups(event) {
        if (event.target.classList.contains('category')) {
            return;
        }
        this.popovers.forEach((popover) => {
            popover.close();
        });
    }
}
